/*import React, { useEffect, useState } from 'react';
import { database } from '../firebaseConfig';
import { ref, set, remove, onValue } from 'firebase/database';
import { useAuth } from '../context/AuthContext';

// Función para establecer al usuario como activo
export const setUserOnline = (userId: string) => {
  set(ref(database, `activeUsers/${userId}`), true);
};

// Función para establecer al usuario como inactivo
export const setUserOffline = (userId: string) => {
  remove(ref(database, `activeUsers/${userId}`));
};

const ActiveUsers: React.FC = () => {
    const { userToken } = useAuth();
    const [userCount, setUserCount] = useState<number>(0);
  
    useEffect(() => {
      if (userToken) {
        setUserOnline(userToken.userId.toString());
      }
  
      const userStatusDatabaseRef = ref(database, 'activeUsers');
      const activeUserListener = onValue(userStatusDatabaseRef, (snapshot) => {
        let activeUsersCount = 0;
        snapshot.forEach((childSnapshot) => {
          if (childSnapshot.val() === true) {
            activeUsersCount += 1;
          }
        });
        setUserCount(activeUsersCount);
      });
  
      // Limpieza al desuscribirse
      return () => {
        if (userToken) {
          setUserOffline(userToken.userId.toString()); 
        }
        activeUserListener();
      };
    }, [userToken]);
  
    return <div>Usuarios conectados: {userCount}</div>;
  };
  
  export default ActiveUsers;
*/

import React, { useEffect, useState } from 'react';
import { ref, set, remove, onValue } from 'firebase/database';
import { database } from '../firebaseConfig';
import { Typography, Box} from '@mui/material';

const INACTIVITY_TIMEOUT = 10 * 60 * 1000;

const ActiveUsers: React.FC = () => {
  const [userCount, setUserCount] = useState<number>(0);

  const userId = localStorage.getItem('userId') || Math.random().toString(36).substring(2, 9);

  useEffect(() => {
    if (!localStorage.getItem('userId')) {
      localStorage.setItem('userId', userId);
    }

    set(ref(database, `activeUsers/${userId}`), true);

    const inactivityTimer = setTimeout(() => {
      remove(ref(database, `activeUsers/${userId}`)); 
    }, INACTIVITY_TIMEOUT);

    const handleBeforeUnload = () => {
      remove(ref(database, `activeUsers/${userId}`)); 
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    const userStatusDatabaseRef = ref(database, 'activeUsers');
    const activeUserListener = onValue(userStatusDatabaseRef, (snapshot) => {
      let activeUsersCount = 0;
      snapshot.forEach((childSnapshot) => {
        if (childSnapshot.val() === true) {
          activeUsersCount += 1;
        }
      });
      setUserCount(activeUsersCount); 
    });

    return () => {
      clearTimeout(inactivityTimer); 
      remove(ref(database, `activeUsers/${userId}`)); 
      window.removeEventListener('beforeunload', handleBeforeUnload); 
      activeUserListener(); 
    };
  }, [userId]);

  return (
    <Box sx={{ display: 'flex',ml:2, mr:2, alignItems: 'center' }}>
         <Typography
            variant="h6"
            sx={{
                fontFamily: "'Roboto Slab', serif",
                color: '#4B4B4B',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                width: { xs: '100%', sm: '50%' },
                mb: { xs: 0, sm: 0 },
                fontSize: {xs:"12px",sm:"14px", md:"16px"}
            }}
            >
            {userCount} visitantes       
        </Typography>
    </Box>
  );
};

export default ActiveUsers;
